import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { formatVal, valToPercent } from '../../../../../../helpers/value'
import TableSectorPerformance from '../../common/table'
import {
  selectCellData,
  selectCompareVal,
  selectDataTable,
  selectLoading,
  selectRowGroup,
} from '../../store/slice'

const TableNumberOfCompanies = ({
  isDynamicReport,
  settingDynamic = {},
  year = '',
}) => {
  const compareValStore = useSelector(selectCompareVal)
  const { compareBetweenRatio: compareValDyn } = settingDynamic
  const compareVal = isDynamicReport ? compareValDyn : compareValStore

  const locale = useSelector((state) => state.i18n.locale)
  const data = useSelector(selectDataTable(compareVal, 'noc'))
  const isLoading = useSelector(selectLoading)
  const titleYear = I18n.t('companyAnalysis.industryAnalysis.YEAR', {
    year: year,
  })

  const headers = [
    {
      title: titleYear,
      colId: 'typeGroup',
      thStyle: {
        justifyContent: 'flex-start',
      },
    },
    {
      title: '',
      colId: 'vsicId',
    },
    {
      title: 'companyAnalysis.industryAnalysis.NUMBER_OF_COMPANIES_1',
      colId: 'count',
      isI18n: true,
      thStyle: {
        justifyContent: 'flex-end',
      },
      format: (val) => formatVal(val, locale, false, 0),
    },
    {
      title: 'companyAnalysis.industryAnalysis.PERCENT_OF_TOTAL_COMPANIES',
      colId: 'percent',
      isI18n: true,
      thStyle: {
        justifyContent: 'flex-end',
      },
      format: (val) => valToPercent(val, locale),
    },
  ]

  return (
    <div style={{ height: isDynamicReport ? 250 : 160 }}>
      <TableSectorPerformance
        dataTable={{
          typeComponent: 'noc',
          data,
          headers,
          selectDataTable,
          selectCellData,
          selectRowGroup,
          isLoading,
          compareVal,
        }}
        isDynamicReport={isDynamicReport}
      />
    </div>
  )
}

export default TableNumberOfCompanies
